import React, { useEffect, useState, useContext } from 'react';
import { Formik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';
import { Form } from 'react-bootstrap';

import WhitePad from '../../../components/common/WhitePad/WhitePad';
import FormRow from '../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../components/common/forms/TextInput/TextInputComponent';
import PrimaryButton from '../../../components/common/forms/Button/PrimaryButton';
import TitleComponent from '../../../components/common/forms/Title/TitleComponent';
import { API_URL, ROLES } from '~/src/utils/constants';
import { autocompleteToList, grantedForRole } from '~/src/utils/misc';
import MyContext from '~/src/services/context';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';
import SvilaClientApi from '~/src/services/api/SvilaClientApi';
import validationSchema from '../validationSchema';
import BorderlessButton from '../../../components/common/forms/Button/BorderlessButton';
import AutocompleteStaticComponent from '~/src/components/common/forms/Autcomplete/AutocompleteStaticComponent';
import { SVILA_CLIENT_STATUS } from '~/src/utils/constants';

export default function SvilaClientEdit(): JSX.Element {
  const { id } = useParams();
  const context = useContext(MyContext);
  const [itemData, setItemData] = useState({
    name: '',
    description: '',
    status: 0,
    svilaClientInfo: null,
    dataArrived: false,
  });
  const history = useHistory();

  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    let result = null;

    const svilaClientInfoEditDto = {
      description: values.svilaClientInfoDecription,
    };

    const svilaClientEditDto = {
      name: values.name,
      description: values.description,
      svilaClientInfo: svilaClientInfoEditDto,
      status: values.status,
    };

    try {
      if (id) {
        result = await SvilaClientApi.update(id, svilaClientEditDto);
      } else {
        result = await SvilaClientApi.create(svilaClientEditDto);
      }

      if (result.status === StatusCodes.OK) {
        history.push('/svila-clients');
      } else {
        setSubmitting(false);
      }
    } catch (error) {
      setSubmitting(false);
    }
  };

  const deleteItem = async () => {
    const result = await SvilaClientApi.delete(id);
    if (result.status === StatusCodes.OK) {
      history.push('/svila-clients');
    }
  };

  const getItem = async () => {
    const result = await SvilaClientApi.getById(id);
    if (result.status === StatusCodes.OK) {
      const newItemData = { ...itemData, ...result.data, dataArrived: true };

      setItemData(newItemData);
    }
  };

  useEffect(() => {
    if (id) {
      getItem(id);
    }
  }, []);

  return (
    <>
      <WhitePad>
        <TitleComponent title={`${id ? 'Edit ' : 'Create '}User`} />

        <FormWrapper>
          {id && itemData.dataArrived === false ? null : (
            <Formik
              initialValues={{
                name: itemData.name || '',
                description: itemData.description || '',
                status: itemData.status || 0,
                svilaClientInfoDecription: itemData.svilaClientInfo?.description || '',
              }}
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                return saveItem(values, setSubmitting);
              }}
            >
              {({
                values,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                errors,
                setFieldValue,
                touched,
              }) => (
                <form onSubmit={handleSubmit} autoComplete="off">
                  <div>
                    <FormRow>
                      <TextInputComponent
                        name="name"
                        label="Name"
                        value={values.name}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        cols={12}
                        errors={errors}
                      />
                    </FormRow>
                  </div>
                  <FormRow>
                    <TextInputComponent
                      name="description"
                      label="Client Description"
                      value={values.description}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={12}
                      errors={errors}
                    />
                  </FormRow>

                  <FormRow>
                    <TextInputComponent
                      name="svilaClientInfoDecription"
                      label="Client Info"
                      value={values.svilaClientInfoDecription}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={12}
                      errors={errors}
                    />
                  </FormRow>
                  <FormRow>
                    <AutocompleteStaticComponent
                      options={Object.values(SVILA_CLIENT_STATUS).map((status) => ({
                        label: status.label,
                        value: status.value,
                      }))}
                      name="status"
                      initialValue={values.status}
                      onChange={(name, value) => setFieldValue(name, value)}
                      getOptionLabel={(option) => option.label}
                      label="Status"
                      cols={12}
                    />
                  </FormRow>

                  <br />
                  <FormRow>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <PrimaryButton
                        variant="primary"
                        isSubmitting={isSubmitting}
                        type="submit"
                        title="Save"
                      />
                      {id && (
                        <BorderlessButton
                          variant="danger"
                          title="Delete"
                          onClick={deleteItem}
                          style={{ marginLeft: '30px' }}
                        />
                      )}

                    </div>
                  </FormRow>
                </form>
              )}
            </Formik>
          )}
        </FormWrapper>
      </WhitePad>
    </>
  );
}
